import React, {Component} from 'react';
import PropTypes from 'prop-types';

class Header extends Component {
	render() {
		return (
			<header className="header-bottom">
				<h1>Управление мобильными приложениями</h1>
				<button className="normal sm-size" onClick={this.props.createNewApp}>Новое приложение</button>
			</header>
		);
	}
}

Header.propTypes = {
	createNewApp: PropTypes.func
};

export default Header;


// WEBPACK FOOTER //
// ./src/components/header.js